export const BUILD_VERSION = {
  "buildNumber": 120,
  "buildDate": "2026_07_14",
  "version": "00120/2026_07_14",
  "releaseVersion": "v1.0.21"
};